import { Header, flexRender } from '@tanstack/react-table';
import { Typography } from '../../atoms/typography/typography';
import { headerCell, sortIndicator } from './variants';
import { IconArrowDown, IconArrowUp, IconDirection } from '@maia/icons';
import { twMerge } from 'tailwind-merge';
import { match } from 'ts-pattern';

type HeadCellProps<TDate, TValue = unknown> = {
  header: Header<TDate, TValue>;
  className?: string;
};

export function HeadCell<TData>(props: HeadCellProps<TData>) {
  const { header, className } = props;

  const canSort = header.column.getCanSort();
  const currentSortingOrder = header.column.getIsSorted();

  return (
    <div
      key={header.id}
      className={twMerge(headerCell(), className)}
      role="columnheader"
    >
      <div
        className="inline-flex items-center cursor-pointer"
        onClick={header.column.getToggleSortingHandler()}
      >
        <Typography
          variant="body-xs"
          weight="medium"
          className="text-grayscale500 whitespace-nowrap"
        >
          {flexRender(header.column.columnDef.header, header.getContext())}
        </Typography>
        {canSort && (
          <span aria-hidden="true">
            {match(currentSortingOrder)
              .with('asc', () => <IconArrowUp />)
              .with('desc', () => <IconArrowDown />)
              .otherwise(() => (
                <IconDirection />
              ))}
          </span>
        )}
      </div>
    </div>
  );
}
